import { FC, createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from "react";

type StepButtonsPortalContextType = {
  portalContainer: HTMLDivElement | null;
  setPortalContainer: Dispatch<SetStateAction<HTMLDivElement | null>>;
};

const StepButtonsPortalContext = createContext<StepButtonsPortalContextType | null>(null);

const StepButtonsPortalProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(null);
  return (
    <StepButtonsPortalContext.Provider value={{ portalContainer, setPortalContainer }}>
      {children}
    </StepButtonsPortalContext.Provider>
  );
};

const useStepButtonsPortal = () => {
  const context = useContext(StepButtonsPortalContext);
  if (!context) throw new Error("useStepButtonsPortal must be used within StepButtonsPortalProvider");
  return context;
};

export { StepButtonsPortalProvider, useStepButtonsPortal };
